import { render, staticRenderFns } from "./maininvoicefilter.vue?vue&type=template&id=5a83a97b"
import script from "./maininvoicefilter.vue?vue&type=script&lang=js"
export * from "./maininvoicefilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports